<template>
    <td>
        <a v-if="showViewLink" :href="viewPath"><i class="fas fa-search"></i></a>
        <a v-if="showEditLink" :href="editPath"><i class="far fa-edit"></i></a>
        <a v-if="showPdfLink" :href="pdfPath" target="_blank"><i class="far fa-file-pdf"></i></a>
        <a v-if="showDownloadLink" :href="downloadPath" target="_blank"><i class="fas fa-file-download"></i></a>
        <a v-if="showExportLink" :href="exportPath" target="_blank"><i class="far fa-file-excel"></i></a>
        <a v-if="showZipLink" :href="zipPath" target="_blank"><i class="far fa-file-archive"></i></a>
        <a v-if="showDeleteLink" :href="deletePath"><i class="far fa-trash-alt"></i></a>
        <a v-if="showViewControl" href="#" :uk-toggle="'target: #' + getViewModalId" @click="activateViewModal"><i class="fas fa-search"></i></a>
        <a v-if="showEditControl" href="#" :uk-toggle="'target: #' + getEditModalId" @click="activateEditModal"><i class="far fa-edit"></i></a>
        <a v-if="showDeleteControl" href="#" :uk-toggle="'target: #' + getDeleteModalId"  @click="activateDeleteModal"><i class="far fa-trash-alt"></i></a>
    </td>
</template>

<script>
    export default {
        name: 'data-table-actions',
        components: {

        },
        props: {
            cell_data: {
                type: Object,
                default: () => {}
            },
            action_data: {
                type: Object,
                default: () => ({
                    view_path:'',
                    edit_path:'',
                    delete_path:'',
                    view_modal:null,
                    edit_modal:null,
                    delete_modal:null
                })
            },
            id_field: {
                type: String,
                default: 'id'
            },
        },
        data(){
            return {

            }
        },
        methods: {
            activateViewModal(){
                this.$root.$refs[this.action_data.view_modal.formRef].loadForm(this.getId);
            },
            activateEditModal(){
                this.$root.$refs[this.action_data.edit_modal.formRef].loadForm(this.getId);
            },
            activateDeleteModal(){
                this.$root.$refs[this.action_data.delete_modal.formRef].loadForm(this.getId);
            }
        },
        computed: {
            showViewLink(){
                return !!this.action_data.view_path && this.action_data.view_path != '';
            },
            showEditLink(){
                return !!this.action_data.edit_path && this.action_data.edit_path != '';
            },
            showPdfLink(){
                return !!this.action_data.pdf_path && this.action_data.pdf_path != '';
            },
            showDownloadLink(){
                return !!this.action_data.download_path && this.action_data.download_path != '';
            },
            showExportLink(){
                return !!this.action_data.export_path && this.action_data.export_path != '';
            },
            showZipLink(){
                return !!this.action_data.zip_path && this.action_data.zip_path != '';
            },
            showDeleteLink(){
                return !!this.action_data.delete_path && this.action_data.delete_path != '';
            },
            showViewControl(){
                return !!this.action_data.view_modal;
            },
            showEditControl(){
                return !!this.action_data.edit_modal;
            },
            showDeleteControl(){
                return !!this.action_data.delete_modal;
            },
            viewPath(){
                return this.action_data.view_path + "/" + this.getId;
            },
            editPath(){
                return this.action_data.edit_path + "/" + this.getId;
            },
            pdfPath(){
                return this.action_data.pdf_path + "/" + this.getId;
            },
            downloadPath(){
                return this.action_data.download_path + "/" + this.getId;
            },
            exportPath(){
                return this.action_data.export_path + "/" + this.getId;
            },
            zipPath(){
                return this.action_data.zip_path + "/" + this.getId;
            },
            deletePath(){
                return this.action_data.delete_path + "/" + this.getId;
            },
            getId(){
                return this.cell_data[this.id_field];
            },
            getViewModalId(){
                if(this.action_data.view_modal){
                    return this.action_data.view_modal.modalId;
                }
                return "0";
            },
            getEditModalId(){
                if(this.action_data.edit_modal){
                    return this.action_data.edit_modal.modalId;
                }
                return "0";
            },
            getDeleteModalId(){
                if(this.action_data.delete_modal){
                    return this.action_data.delete_modal.modalId;
                }
                return "0";
            }
        }
    }
</script>
